<template>
  <v-container class="public-page-container" fill-height fluid>
    <v-row class="pa-10">
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" lg="4" xl="3">
        <v-card class="white login-card rounded pa-5 pa-md-10">
          <div>
            <h2 class="mb-10 primary--text">Sign In</h2>
          </div>
          <v-row>
            <g-signin-button
              :params="googleSignInParams"
              @success="onSignInSuccess"
              @error="onSignInError"
              class="google-sign-in-container"
            >
              <v-btn class="text-none" color="black" outlined block>
                <v-img alt="Logo" :src="googleLogo" max-width="25" />
                <span>Sign in with BSE google</span>
              </v-btn>
            </g-signin-button>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import googleLogo from "@/assets/google.png";
import authService from "@/services/auth-service";
import notificationsUtility from "@/utilities/notifications-utility";
export default {
  name: "LoginView",
  data: () => ({
    googleLogo,
    googleSignInParams: {
      client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
      plugin_name: "BSE",
    },
  }),
  methods: {
    onSignInSuccess(googleUser) {
      authService
        .login({ token: googleUser.getAuthResponse().id_token })
        .then(() => {
          this.$router.push({ name: "home" });
        });
    },
    onSignInError() {
      notificationsUtility.pushNotification({
        message: "Something went wrong. Please contact the system admin",
        type: "error",
      });
    },
  },
};
</script>
